import { arrayRemove, arrayUnion, doc, updateDoc } from "firebase/firestore";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { db } from "../../backend/firebase";

const Collections = ({ collections: initialCollections, datasetid, uid }) => {
  const navigate = useNavigate();
  const [collections, setCollections] = useState(initialCollections);

  const toggleSave = async (collection) => {
    const isSaved = collection.datasets?.includes(datasetid);
    const collectionPath = collection.isPrivate
      ? doc(db, "Users", uid, "collections", collection.id)
      : doc(db, "collections", collection.id);

    await updateDoc(collectionPath, {
      datasets: isSaved ? arrayRemove(datasetid) : arrayUnion(datasetid),
    });

    const updated = collections.map((col) => {
      if (col.id === collection.id) {
        const updatedDatasets = isSaved
          ? col.datasets?.filter((id) => id !== datasetid)
          : [...(col.datasets || []), datasetid];
        return { ...col, datasets: updatedDatasets };
      }
      return col;
    });

    setCollections(updated);
  };

  return (
    <div style={{ margin: 10 }}>
      <div
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
          marginBottom: 20
        }}
      >
        <h2 style={{ color: "white", margin: 0 }}>My SETA Collections</h2>
        <span
          onClick={() => navigate(`/add-collection/${uid}`)}
          style={{
            backgroundColor: "#667eea",
            borderWidth: 0,
            borderStyle: "solid",
            width: "10%",
            minWidth: "120px",
            borderRadius: 5,
            color: "white",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: 10,
            cursor: "pointer",
            fontWeight: 300,
            fontSize: 14
          }}
        >
          Add Collection
        </span>
      </div>

      {collections.length === 0 ? (
        <div
          style={{
            border: "1px dashed #333",
            borderRadius: 8,
            padding: "40px 20px",
            textAlign: "center",
            backgroundColor: "rgba(255, 255, 255, 0.02)"
          }}
        >
          <h3
            style={{
              color: "#e2e8f0",
              fontSize: "18px",
              fontWeight: "600",
              margin: "0 0 8px 0"
            }}
          >
            No collections yet
          </h3>
          <p
            style={{
              color: "#888",
              fontSize: "14px",
              margin: "0 0 20px 0",
              lineHeight: "1.5"
            }}
          >
            Create your first collection to start organizing datasets
          </p>
        </div>
      ) : (
        collections.map((collectionData) => (
          <div
            key={collectionData.id}
            style={{
              borderWidth: 0.5,
              borderColor: "#1a1a1a",
              borderStyle: "solid",
              paddingBottom: 15,
              borderRadius: 5,
              marginBottom: 15,
              backgroundColor: "rgba(255, 255, 255, 0.02)",
              transition: "all 0.2s ease"
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.borderColor = "#333";
              e.currentTarget.style.backgroundColor = "rgba(255, 255, 255, 0.05)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.borderColor = "#1a1a1a";
              e.currentTarget.style.backgroundColor = "rgba(255, 255, 255, 0.02)";
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between",
                marginLeft: 10,
                marginRight: 10,
                paddingTop: 10
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  margin: 10,
                  gap: 10,
                }}
              >
                <p style={{ color: "white", fontWeight: 300, margin: 0 }}>
                  <b>{collectionData.collectionName}</b>
                </p>
              </div>
              <div
                style={{
                  borderWidth: 0.5,
                  borderColor: "#667eea",
                  borderStyle: "solid",
                  borderRadius: 3,
                  color: "#667eea",
                  width: 'auto',
                  minWidth: '60px',
                  fontSize: 12,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  padding: "4px 8px",
                  fontWeight: 500,
                  textTransform: "uppercase",
                  letterSpacing: "0.5px"
                }}
              >
                {collectionData.isPrivate ? "Private" : "Public"}
              </div>
            </div>

            <div
              style={{
                color: "#888",
                marginLeft: 20,
                marginRight: 10,
                fontSize: 14,
                lineHeight: "1.4",
                marginBottom: 15
              }}
            >
              {collectionData.description || "No description provided"}
            </div>

            <div
              onClick={() => toggleSave(collectionData)}
              style={{
                backgroundColor: !collectionData.datasets?.includes(datasetid) ? "#667eea" : "#1a1a1a",
                border: collectionData.datasets?.includes(datasetid) ? "1px solid #333" : "none",
                padding: 10,
                color: "white",
                fontSize: 14,
                margin: 10,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
                borderRadius: 5,
                fontWeight: 400,
                transition: "all 0.2s ease"
              }}
              onMouseEnter={(e) => {
                if (!collectionData.datasets?.includes(datasetid)) {
                  e.target.style.backgroundColor = "#5a6fd8";
                  e.target.style.transform = "translateY(-1px)";
                } else {
                  e.target.style.backgroundColor = "#2a2a2a";
                  e.target.style.borderColor = "#444";
                }
              }}
              onMouseLeave={(e) => {
                if (!collectionData.datasets?.includes(datasetid)) {
                  e.target.style.backgroundColor = "#667eea";
                  e.target.style.transform = "translateY(0)";
                } else {
                  e.target.style.backgroundColor = "#1a1a1a";
                  e.target.style.borderColor = "#333";
                }
              }}
            >
              {collectionData.datasets?.includes(datasetid)
                ? "Remove from Collection"
                : "Save to Collection"}
            </div>
          </div>
        ))
      )}
    </div>
  );
};

export default Collections;